/* eslint-disable max-lines */
import React, { Component } from 'react';
import { when } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import Info from '@material-ui/icons/Info';

import CookieStorageService from 'services/CookieStorageService';
import FirebaseRoomService from 'services/FirebaseRoomService';
import { translate } from 'services/i18nService';
import messagingService from 'services/MessagingService/MessagingService';
import {
  HLS_DEBUG,
  PRIVATE_SHOW_REQUEST_SHOULD_CANCEL,
  REINIT_ROOM,
} from 'services/MessagingService/EventNames';
import MetaService from 'services/MetaService';
import ModalService from 'services/ModalService';
import PlayerService from 'services/Streaming/PlayerService';
import SessionStorageService from 'services/SessionStorageService';
import TrackingService from 'services/TrackingService';
import VideoAdService from 'services/adServices/VideoAdService';
import BroadcasterStore from 'stores/BroadcasterStore';
import ChatStore from 'stores/ChatStore';
import FirebaseStore from 'stores/FirebaseStore';
import GroupShowStore from 'stores/GroupShowStore';
import PeekStore from 'stores/PeekStore';
import ProfileStore from 'stores/ProfileStore';
import TippingStore from 'stores/TippingStore';
import UserStore from 'stores/UserStore';
import PrivateDirectoryStore from 'pages/PrivateDirectory/PrivateDirectoryStore';
import { PS_ACTIONS } from 'pages/PrivateDirectory/config';
import NotificationRenderer from 'pages/NotificationRenderer/NotificationRenderer';
import BoostAnimation from 'components/BoostAnimation/BoostAnimation';
import CampaignOnCamAnimation from 'components/CampaignOnCamAnimation/CampaignOnCamAnimation';
import DesktopBroadcastBannedState from 'components/DesktopBroadcastBannedState/DesktopBroadcastBannedState';
import DesktopBroadcastDisconnected from 'components/DesktopBroadcastDisconnected/DesktopBroadcastDisconnected';
import DesktopBroadcastEnterSpy from 'components/DesktopBroadcastEnterSpy/DesktopBroadcastEnterSpy';
import DesktopBroadcastKickedState from 'components/DesktopBroadcastKickedState/DesktopBroadcastKickedState';
import DesktopBroadcastLockedChat from 'components/DesktopBroadcastLockedChat/DesktopBroadcastLockedChat';
import DesktopBroadcastPaused from 'components/DesktopBroadcastPaused/DesktopBroadcastPaused';
import DesktopBroadcastPrivateRoom from 'components/DesktopBroadcastPrivateRoom/DesktopBroadcastPrivateRoom';
import DesktopBroadcastReconnect from 'components/DesktopBroadcastReconnect/DesktopBroadcastReconnect';
import DesktopGroupTicketBar from 'components/DesktopGroupTicketBar/DesktopGroupTicketBar';
import DesktopStreaming from 'components/DesktopStreaming/DesktopStreaming';
import DesktopTipBar from 'components/DesktopTipBar/DesktopTipBar';
import GroupShowDesktop from 'components/GroupShowDesktop/GroupShowDesktop';
import GroupShowDisconnectedState from 'components/GroupShowDisconnectedState/GroupShowDisconnectedState';
import GroupShowWithoutTicket from 'components/GroupShowWithoutTicket/GroupShowWithoutTicket';
import MobileShowTransition from 'components/MobileShowTransition/MobileShowTransition';
import MobilePrivateShowEnded from 'components/MobilePrivateShowEnded/MobilePrivateShowEnded';
import PeekStream from 'components/PeekStream/PeekStream';
import PeekEventStream from 'pages/ProfileV2/PeekEventStream';
import { ControlledFeatureService } from 'services';
import controlledFeatures from 'enum/controlledFeatures';
import {
  BROADCAST_STATUS,
  NEW_SHOWS_STATE,
  VIDEO_AND_CHAT_CLASS,
} from 'enum/videoPlayer';
import {
  SHORT_SHOW_REGISTRATION_MODAL_AFTER_ENTERING_CAM,
  SHOW_REGISTRATION_MODAL_AFTER_ENTERING_CAM,
  SHOW_REGISTRATION_MODAL_REPEAT,
} from 'enum/helpers';
import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';
import allUserGroups from 'enum/userGroups';
import { STREAM_PROVIDERS, STREAM_RECONNECT_TIMEOUT } from 'utils/consts';
import {
  generateID,
  isUserSpyTicketHolder,
} from 'utils/helpers';
import { setPrivateShowAction } from 'webchat/webchatCalls';
import ThemeService from 'themes/ThemeService';
import { DAY_AS_MILLISECONDS, MINUTE_AS_MILLISECONDS } from 'enum/timeFormat';
import { RegistrationModalCaller } from 'pages/RegistrationModal/utils';
import FeedsCarouselDesktopWrapper from 'components/FeedsCarousel/DesktopWrapper';

import { FIREBASE_AUTH_STATUS } from '../../../../../firebase/firebaseStructure';
import ChatTabs from '../Chat/ChatTabs/ChatTabs';

import Cam2CamBroadcast from './Cam2CamBroadcast';
import styles from './DesktopBroadcast.css';


const POLLING_INTERVAL = 8000;
const DEFAULT_ON_CAM_ANIMATION_DELAY = 3 * MINUTE_AS_MILLISECONDS;
const ON_CAM_CLOSED_COOKIE_LIFETIME = 2 * DAY_AS_MILLISECONDS;
const ON_CAM_CLOSED_COOKIE_LIFETIME_GOLD_MEMBERS = 7 * DAY_AS_MILLISECONDS;

@observer
class DesktopBroadcast extends Component {
  static propTypes = {
    appActions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    paymentActions: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    authDataStatus: PropTypes.string,
    broadcastStatus: PropTypes.string,
    disconnectTimestamp: PropTypes.number,
    embedProfileV2: PropTypes.bool,
    match: PropTypes.object,
    newShowsDetails: PropTypes.object,
    newShowsState: PropTypes.string,
    registrationModalClosedFirstTime: PropTypes.bool,
    roomDataReady: PropTypes.bool,
    setShowRegistrationModal: PropTypes.func,
    showBuyTokensModal: PropTypes.func,
    showRegistrationModal: PropTypes.bool,
    spyRequestInProgress: PropTypes.bool,
    userHoldGroupShowTicket: PropTypes.bool,
    walletDetails: PropTypes.object,
  };

  static defaultProps = {
    authDataStatus: undefined,
    broadcastStatus: undefined,
    disconnectTimestamp: 0,
    embedProfileV2: false,
    match: undefined,
    newShowsDetails: undefined,
    newShowsState: undefined,
    roomDataReady: false,
    userHoldGroupShowTicket: false,
    setShowRegistrationModal: () => undefined,
    showRegistrationModal: false,
    showBuyTokensModal: () => undefined,
    spyRequestInProgress: () => undefined,
    walletDetails: undefined,
    registrationModalClosedFirstTime: false,
  };

  constructor(...args) {
    super(...args);

    const { user } = this.props;

    this.state = {
      showOnCamAnimation: false,
      psOfflineRequest: false,
    };

    this.polingTimer = null;
    this.onCamAnimationTimer = null;
    this.metaService = new MetaService();
    this.showRegistrationModalTimer = null;
    this.streamReconnectTimer = null;
    this.messagingService = messagingService();
    this.messagingService.on(REINIT_ROOM, this.reInitPS);
    this.messagingService.on(HLS_DEBUG, this.handleAdChange);
    this.disableFormOverlay = ControlledFeatureService.setUser(user).has(
      controlledFeatures.DISABLE_REGISTRATION_OVERLAY
    );

    this.IDS = {
      prefix: 'COVID20',
      element: 'DesktopBroadcast',
      goPrivate: 'goPrivate',
    };
    this.makeId = generateID(this.IDS.prefix, this.IDS.element);
  }

  componentDidMount() {
    const { user, match, setShowRegistrationModal } = this.props;
    const { tippingSessionId } = FirebaseStore;
    const { performerDetails } = ProfileStore;

    const roomName = match.params.user.toLowerCase();
    const isBroadcasting = ProfileStore.performerDetails.online;
    const shortDelayRegister = UserStore.hasCF(allUserGroups.SIGN_UP_OVERLAY_SHORT_DELAY);
    this.metaService.setMetaContent(
      translate('v2profile.seo.main.description', { 0: performerDetails.username }),
      translate('v2profile.seo.main.title', { 0: performerDetails.username })
    );
    const customMetaObject = {
      ogType: 'video.other',
      ogUrl: window.location.href,
      ogImage: performerDetails.profileImageUrl,
      videoActor: match.params.user,
    };
    this.metaService.setCustomMeta(customMetaObject);
    if (isBroadcasting) {
      TippingStore.getTippingInfo(user.username, roomName, user, tippingSessionId);
      this.startPolling();
      this.handleOnCamAnimation();
      this.handleBroadcastStatus();
    }
    document.querySelector('#streamWrap').addEventListener('contextmenu', (e) => e.preventDefault());
    let timer = SHOW_REGISTRATION_MODAL_AFTER_ENTERING_CAM;
    if (shortDelayRegister) {
      timer = SHORT_SHOW_REGISTRATION_MODAL_AFTER_ENTERING_CAM;
    }
    if (!this.disableFormOverlay) {
      if (user.username === null && SessionStorageService.get('registrationModalEnteringCam') !== roomName) {
        this.showRegistrationModalTimer = setTimeout(() => {
          if (!ModalService.isModalActive()) {
            setShowRegistrationModal(true, RegistrationModalCaller.DESKTOP_BROADCAST);
          }
        }, timer);
      }
    }

    when(
      () => FirebaseStore.isPrivateRoom,
      () => {
        VideoAdService.destroy();
      }
    );
  }

  // eslint-disable-next-line complexity
  componentDidUpdate(prevProps) {
    const {
      broadcastStatus,
      getStreamingInfo,
      playToken,
      setBroadcastStatus,
      setPublicShowEnded,
      setStreamHasEndedState,
      stopPS,
    } =
      ProfileStore;
    const { groupShowTimer, setRemainingTimeGroupShow, isBonusTimeVisible } = GroupShowStore;
    const { privateRoom, isPrivateShowRequestActive, togglePrivateShowRequest, isUserInRoster, streamingProvider } =
      FirebaseStore;
    const { setShowRegistrationModal, registrationModalClosedFirstTime, showRegistrationModal, user } = this.props;
    if (prevProps.user.username !== this.props.user.username) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ showOnCamAnimation: false }, () => this.handleOnCamAnimation());
    }
    const roomName = this.props.match.params.user.toLowerCase();
    const privateShowEnded =
      prevProps.broadcastStatus === BROADCAST_STATUS.ACCEPTED_INSIDE_PS &&
      broadcastStatus !== BROADCAST_STATUS.ACCEPTED_INSIDE_PS &&
      SessionStorageService.get('privateShowTransitionDone');
    const { closeGroupShowTransitioning } = GroupShowStore;
    const wasAcceptingNewShow = prevProps.newShowsState === NEW_SHOWS_STATE.ACCEPTING;
    const isEndingNewShow = wasAcceptingNewShow && !privateRoom;
    const wasPlaying = prevProps.broadcastStatus === BROADCAST_STATUS.PLAYING;
    const showEnded = this.props.newShowsState === NEW_SHOWS_STATE.SHOW_ENDED;
    const hasEndedNormal = wasPlaying && showEnded;
    const wasReconnecting = prevProps.broadcastStatus === BROADCAST_STATUS.RECONNECTING;
    const isAcceptingNewShow = this.props.newShowsState === NEW_SHOWS_STATE.ACCEPTING;
    const hasEndedAbnormal = wasReconnecting && isAcceptingNewShow;
    const isPublicShowEnded = isEndingNewShow && (hasEndedNormal || hasEndedAbnormal);

    if (isPublicShowEnded) {
      setPublicShowEnded(true);
    }

    const timeToStartGroupShowExpired =
      prevProps.newShowsState === NEW_SHOWS_STATE.GS_GOAL_REACHED &&
      this.props.newShowsState === NEW_SHOWS_STATE.ACCEPTING;
    const notEnoughTicketsBought =
      prevProps.newShowsDetails &&
      (this.props.newShowsDetails === null || this.props.newShowsDetails === undefined) &&
      prevProps.userHoldGroupShowTicket === true &&
      this.props.userHoldGroupShowTicket === false &&
      this.props.newShowsState !== undefined &&
      this.props.newShowsState !== NEW_SHOWS_STATE.PAUSE_TIMEOUT &&
      prevProps.newShowsState !== NEW_SHOWS_STATE.PAUSE_TIMEOUT &&
      prevProps.newShowsState !== NEW_SHOWS_STATE.PAUSED_GS && groupShowTimer <= 1;
    const userDidntStartedGroupShow =
      prevProps.userHoldGroupShowTicket === true &&
      this.props.userHoldGroupShowTicket === false &&
      prevProps.newShowsState === NEW_SHOWS_STATE.GS_GOAL_REACHED &&
      this.props.newShowsState === NEW_SHOWS_STATE.GS_SELLING_TICKETS_UNSUCCESSFUL;
    const isBroadcasterEndedGroupShow =
      (prevProps.newShowsState === NEW_SHOWS_STATE.INSIDE_GS || prevProps.newShowsState === NEW_SHOWS_STATE.BONUS_GS) &&
      this.props.newShowsState === NEW_SHOWS_STATE.PAUSED &&
      groupShowTimer > 1 &&
      this.props.userHoldGroupShowTicket;
    const groupShowCanceled =
      notEnoughTicketsBought || userDidntStartedGroupShow || timeToStartGroupShowExpired || isBroadcasterEndedGroupShow;
    const skipTransitionInGS =
      prevProps.newShowsState === NEW_SHOWS_STATE.PAUSED_GS && this.props.newShowsState === NEW_SHOWS_STATE.INSIDE_GS;
    const groupShowGoalReached =
      this.props.userHoldGroupShowTicket &&
      this.props.newShowsState === NEW_SHOWS_STATE.GS_GOAL_REACHED &&
      prevProps.newShowsState === NEW_SHOWS_STATE.GS_SELLING_TICKETS;
    const transitionIntoGS =
      (prevProps.roomDataReady !== this.props.roomDataReady &&
        this.props.newShowsState === NEW_SHOWS_STATE.INSIDE_GS) ||
      (this.props.newShowsState === NEW_SHOWS_STATE.INSIDE_GS && this.props.roomDataReady) ||
      (prevProps.newShowsState === null &&
        (this.props.newShowsState === NEW_SHOWS_STATE.BONUS_GS ||
          this.props.newShowsState === NEW_SHOWS_STATE.PAUSED_GS));
    const reconnectingStateAfterPausedGS =
      (prevProps.newShowsState === NEW_SHOWS_STATE.PAUSED_GS &&
        this.props.newShowsState === NEW_SHOWS_STATE.ACCEPTING) ||
      (prevProps.newShowsState === NEW_SHOWS_STATE.INSIDE_GS && this.props.newShowsState === NEW_SHOWS_STATE.ACCEPTING);
    const shouldCancelPSRequest =
      isPrivateShowRequestActive &&
      (
        (
          this.props.broadcastStatus !== prevProps.broadcastStatus &&
          prevProps.broadcastStatus === BROADCAST_STATUS.PLAYING &&
          [BROADCAST_STATUS.INSIDE_GS, BROADCAST_STATUS.INSIDE_PS].includes(this.props.broadcastStatus)
        ) ||
        prevProps.newShowsState !== this.props.newShowsState
      );
    const disconnectedBroadcasterStartedBroadcastingAgain =
      prevProps.broadcastStatus === BROADCAST_STATUS.DISCONNECTED && broadcastStatus === BROADCAST_STATUS.PLAYING;
    const disconnectedInPrivateRoomScreen =
      prevProps.authDataStatus === FIREBASE_AUTH_STATUS.privateRoom &&
      this.props.authDataStatus === FIREBASE_AUTH_STATUS.roomOffline;
    const goingFromPausedToPublicState =
      prevProps.newShowsState === NEW_SHOWS_STATE.PAUSED && this.props.newShowsState === NEW_SHOWS_STATE.ACCEPTING;
    const goingFromDisconnectedToPublic = prevProps.disconnectTimestamp && !this.props.disconnectTimestamp;
    const shouldInitWebPresence =
      (goingFromPausedToPublicState || goingFromDisconnectedToPublic) &&
      this.props.user.username &&
      !isUserInRoster(this.props.user.username) &&
      !UserStore.isMinUserModerator;

    const isGroupShowPaused =
      this.props.newShowsState === NEW_SHOWS_STATE.PAUSED ||
      prevProps.newShowsState === NEW_SHOWS_STATE.PAUSED;
    const isUserInsideGroupShow =
      prevProps.newShowsState === NEW_SHOWS_STATE.INSIDE_GS ||
      prevProps.newShowsState === NEW_SHOWS_STATE.BONUS_GS;

    // TODO: cleanup this flag as part of SSS-1541
    const isGroupShowEndedNormalWithoutStatusChange = (
      prevProps.newShowsState === NEW_SHOWS_STATE.PAUSED
      && ProfileStore.broadcastStatus === BROADCAST_STATUS.INSIDE_GS
      && this.props.newShowsState === NEW_SHOWS_STATE.ACCEPTING
    );

    const switchedToWowza = (
      streamingProvider &&
      this.previousStreamingProvider &&
      streamingProvider !== this.previousStreamingProvider &&
      streamingProvider === STREAM_PROVIDERS.WOWZA
    );

    const broadcastRestarted = (
      prevProps.broadcastStatus !== broadcastStatus &&
      !disconnectedBroadcasterStartedBroadcastingAgain
    );

    if (switchedToWowza || broadcastRestarted) {
      getStreamingInfo();
    }

    this.previousStreamingProvider = streamingProvider;

    const groupShowEndedNormal =
      isGroupShowPaused &&
      isUserInsideGroupShow &&
      groupShowTimer <= 1 &&
      prevProps.userHoldGroupShowTicket;
    if (disconnectedInPrivateRoomScreen) {
      setBroadcastStatus(BROADCAST_STATUS.DISCONNECTED);
    }
    if (isGroupShowEndedNormalWithoutStatusChange || reconnectingStateAfterPausedGS) {
      setBroadcastStatus(BROADCAST_STATUS.RECONNECTING);
      setStreamHasEndedState(true);
    }
    if (groupShowCanceled) {
      setBroadcastStatus(BROADCAST_STATUS.UNKNOWN);
      setRemainingTimeGroupShow(0);
      if (prevProps.userHoldGroupShowTicket && !isBonusTimeVisible && !groupShowEndedNormal) {
        ModalService.showModal(ModalService.MODAL_KEYS.GROUP_SHOW_CANCELED_MODAL);
      }
    }
    if (groupShowEndedNormal) {
      setBroadcastStatus(BROADCAST_STATUS.UNKNOWN);
    }
    if (groupShowGoalReached) {
      ModalService.showModal(ModalService.MODAL_KEYS.GROUP_SHOW_GOAL_REACHED_MODAL);
    }

    if (shouldInitWebPresence) {
      FirebaseRoomService.initWebPresence(roomName, this.props.user.username.toLowerCase());
    }

    if (skipTransitionInGS) {
      closeGroupShowTransitioning(false);
    }

    if (transitionIntoGS) {
      setBroadcastStatus(BROADCAST_STATUS.INSIDE_GS);
    }
    this.handleBroadcastStatus();

    if (shouldCancelPSRequest) {
      togglePrivateShowRequest(false);
      this.messagingService.emit(PRIVATE_SHOW_REQUEST_SHOULD_CANCEL);
    }

    if (privateShowEnded) {
      SessionStorageService.remove('privateShowTransitionDone');
      if (!privateRoom) {
        UserStore.setWebRTCSource(null);
        ProfileStore.setPrivateHls(null);
        ProfileStore.setPlayToken(undefined);
      }
      // if PS is ended by performer
      if (playToken) {
        stopPS();
      }
    }

    if (
      user.username === null &&
      registrationModalClosedFirstTime &&
      !showRegistrationModal
    ) {
      setTimeout(() => {
        setShowRegistrationModal(true, RegistrationModalCaller.DESKTOP_BROADCAST_REPEAT);
      }, SHOW_REGISTRATION_MODAL_REPEAT);
    }
  }

  componentWillUnmount() {
    const streamWrapQuery = document.querySelector('#streamWrap');
    clearInterval(this.polingTimer);
    clearTimeout(this.onCamAnimationTimer);
    clearTimeout(this.showRegistrationModalTimer);
    clearTimeout(this.streamReconnectTimer);
    if (streamWrapQuery) {
      streamWrapQuery.removeEventListener('contextmenu', (e) => e.preventDefault());
    }
    this.metaService.setMetaContent('', 'CAM4');
  }

  reInitPS = () => {
    const { broadcastStatus } = ProfileStore;
    const { streamingProvider } = FirebaseStore;
    if (broadcastStatus === BROADCAST_STATUS.ACCEPTED_INSIDE_PS && streamingProvider === STREAM_PROVIDERS.CEEBLUE) {
      this.handlePrivateShowAction('requestPlayToken');
    }
  };

  startPolling = () => {
    this.polingTimer = setInterval(() => {
      const { user, match } = this.props;
      const { tippingSessionId } = FirebaseStore;
      const { getTippingInfo } = TippingStore;
      const roomName = match.params.user.toLowerCase();
      getTippingInfo(user.username, roomName, user, tippingSessionId);
    }, POLLING_INTERVAL);
  };

  // eslint-disable-next-line complexity
  handleBroadcastStatus = () => {
    const { username, accessLevel, accessHash } = this.props.user;
    const { spyRequestInProgress } = this.props;
    const isAdmin = accessLevel >= ACCESS_LEVEL_NUM.ADMIN;
    const roomName = this.props.match.params.user.toLowerCase();
    const {
      broadcastStatus,
      setBroadcastStatus,
      setStreamHasEndedState,
      setPrivateShowEnded,
      setSpyShowEnded,
      setSpyShowStartTime,
      setPrivateShowStartTime,
      spyShowRequested,
      spyShowEnded,
      privateShowRequested,
      adminSpyShowTime,
    } = ProfileStore;
    const { disconnectTimestamp, online, togglePrivateShowRequest, newShowsState, newShowsDetails } = FirebaseStore;
    const showEnded = newShowsState === NEW_SHOWS_STATE.SHOW_ENDED;
    const reconnecting =
      !showEnded &&
      !online &&
      disconnectTimestamp > 0 &&
      broadcastStatus !== BROADCAST_STATUS.RECONNECTING &&
      broadcastStatus !== BROADCAST_STATUS.DISCONNECTED;
    const playing =
      !showEnded &&
      online &&
      broadcastStatus !== BROADCAST_STATUS.PLAYING &&
      (broadcastStatus !== BROADCAST_STATUS.INSIDE_PS ||
        (broadcastStatus === BROADCAST_STATUS.INSIDE_PS && newShowsState === NEW_SHOWS_STATE.ACCEPTING)) &&
      broadcastStatus !== BROADCAST_STATUS.ACCEPTED_INSIDE_PS &&
      broadcastStatus !== BROADCAST_STATUS.INSIDE_GS &&
      newShowsState !== NEW_SHOWS_STATE.PAUSED &&
      newShowsState !== NEW_SHOWS_STATE.PAUSE_TIMEOUT &&
      broadcastStatus !== BROADCAST_STATUS.SPYING;
    if (reconnecting) {
      setBroadcastStatus(BROADCAST_STATUS.RECONNECTING);
      setStreamHasEndedState(true);
      setSpyShowEnded(false);
    }

    if (playing) {
      if (!ProfileStore.streamingSource) {
        const timeout = ProfileStore.isPlayerBroadcastMode ? 0 : STREAM_RECONNECT_TIMEOUT;
        this.streamReconnectTimer = setTimeout(() => {
          ProfileStore.getStreamingInfo(roomName);
          setBroadcastStatus(BROADCAST_STATUS.PLAYING);
          // Needed due to backend propagation issues, stream details sometimes not returned immediately
        }, timeout);
      } else {
        setBroadcastStatus(BROADCAST_STATUS.PLAYING);
      }
    }
    if (showEnded) {
      setBroadcastStatus(BROADCAST_STATUS.DISCONNECTED);
    }

    // offline PS request (from Private Directory)
    const isUserInTheRoom = FirebaseStore.isUserInRoster(username);
    const sessionStoragePSOffline = SessionStorageService.get('PrivateShowOfflineRequest');

    if (
      isUserInTheRoom &&
      sessionStoragePSOffline &&
      sessionStoragePSOffline.toLowerCase() === roomName.toLowerCase()
    ) {
      this.setState({ psOfflineRequest: true });
      PrivateDirectoryStore.privateShowAction({
        action: PS_ACTIONS.START_PS,
        roomname: roomName,
        username,
        accessHash,
        billedUsername: username,
      });
      SessionStorageService.set('PrivateShowOfflineRequest', '');
    }
    // broadcaster goes to private show
    if (newShowsState === NEW_SHOWS_STATE.INSIDE_PS && broadcastStatus !== BROADCAST_STATUS.ACCEPTED_INSIDE_PS) {
      setPrivateShowEnded(false);
      let userIsTicketHolder = false;
      if (newShowsDetails && newShowsDetails.ticketHolders) {
        // eslint-disable-next-line array-callback-return
        newShowsDetails.ticketHolders.map((ticketHolder) => {
          if (username && ticketHolder === username.toLowerCase()) {
            userIsTicketHolder = true;
          }
        });
      }

      const userIsSpyTicketHolder =
        (username &&
          newShowsDetails &&
          newShowsDetails.spyTicketHolders &&
          isUserSpyTicketHolder(newShowsDetails.spyTicketHolders, username.toLowerCase())) ||
        (isAdmin && ProfileStore.adminSpyShowRequested);

      // viewer goes to private show
      if (userIsTicketHolder || this.state.psOfflineRequest) {
        if (!privateShowRequested) {
          this.handlePrivateShowAction('requestPlayToken');
        }
        togglePrivateShowRequest(false);
        setBroadcastStatus(BROADCAST_STATUS.ACCEPTED_INSIDE_PS);
        setPrivateShowStartTime(newShowsDetails.startTime);
        TrackingService.track({
          event: 'Private Show',
          eventAction: 'Start Private Show',
          eventValue: `${ProfileStore.profileName}:{${username}}`,
        });
      } else {
        // check if user goes to spy
        // eslint-disable-next-line no-lonely-if
        if (userIsSpyTicketHolder) {
          if (broadcastStatus !== BROADCAST_STATUS.SPYING) {
            setSpyShowEnded(false);
            const time = isAdmin ? adminSpyShowTime : newShowsDetails.spyTicketHolders[username.toLowerCase()];
            setSpyShowStartTime(time);
            if (!spyRequestInProgress) {
              setBroadcastStatus(BROADCAST_STATUS.SPYING);
            }
            if (!spyShowRequested) {
              this.handlePrivateShowAction('requestPlayToken');
            }
          }
        } else if (!spyShowEnded) {
          setBroadcastStatus(BROADCAST_STATUS.INSIDE_PS);
        }
      }
    }
  };

  handlePrivateShowAction = (action, blocksOfTimeIndex = 0, loggedOutUser, cam2cam = false) => {
    const { username, accessHash } = this.props.user;
    const roomname = this.props.match.params.user.toLowerCase();
    const { privateShowBlocksOfTimeActive, privateShowBlocksOfTime } = FirebaseStore;
    const { setSpyShowRequested, setPrivateShowRequested, broadcastStatus } = ProfileStore;
    const requestData = {
      action,
      extend: false,
      username,
      accessHash,
      roomname,
      cam2cam,
    };

    if (action === 'request') {
      ProfileStore.isCam2CamPSRequest = cam2cam;
    }

    const userIsLoggedOut =
      !username && !accessHash && loggedOutUser && loggedOutUser.username && loggedOutUser.accessHash;

    if (userIsLoggedOut && action === 'cancelRequest') {
      requestData.username = loggedOutUser.username;
      requestData.accessHash = loggedOutUser.accessHash;
    }

    if (action === 'requestPlayToken') {
      setPrivateShowRequested(true);
    } else {
      setPrivateShowRequested(false);
    }

    if (action === 'startSpy') {
      setSpyShowRequested(true);
    }

    if (privateShowBlocksOfTimeActive === '1' && !action.toLowerCase().includes('spy')) {
      const privateShowBlock = privateShowBlocksOfTime && privateShowBlocksOfTime.split('|');
      requestData.blockOfTime = privateShowBlock[blocksOfTimeIndex];
    }

    if (
      broadcastStatus === BROADCAST_STATUS.ACCEPTED_INSIDE_PS &&
      requestData.blockOfTime &&
      !action.toLowerCase().includes('stop')
    ) {
      requestData.extend = true;
    }

    return setPrivateShowAction(requestData);
  };

  // eslint-disable-next-line complexity
  handleRenderVideoState = () => {
    const {
      user,
      match,
      setShowRegistrationModal,
      walletDetails,
      showBuyTokensModal,
      newShowsDetails,
      userHoldGroupShowTicket,
      roomDataReady,
      embedProfileV2,
    } = this.props;

    const {
      broadcastStatus,
      externalProfile,
      privateShowReady,
      privateShowEnded,
      publicShowEnded,
      realityShow,
      spyShowEnded,
    } = ProfileStore;

    const { newShowsState, isPrivateRoom, authData, isUserInRoster, userKickedStatus, isBanned } = FirebaseStore;
    const roomName = match.params.user.toLowerCase();
    const isAdmin = user.accessLevel >= ACCESS_LEVEL_NUM.ADMIN;
    // TODO: this has to be removed once we fully transfer profiles to v2
    const guestPrivateRoom = authData.status === FIREBASE_AUTH_STATUS.privateRoom && !user.username;
    const isSfw = user.user.getIn(['user', 'sfw']);

    const shouldExitFullscreen =
      document.fullscreen &&
      ((broadcastStatus === BROADCAST_STATUS.PLAYING && newShowsState === NEW_SHOWS_STATE.PAUSED) ||
        (broadcastStatus === BROADCAST_STATUS.UNKNOWN && newShowsState === NEW_SHOWS_STATE.PAUSED) ||
        (broadcastStatus === BROADCAST_STATUS.INSIDE_GS &&
          (newShowsState === NEW_SHOWS_STATE.PAUSED_GS || !userHoldGroupShowTicket)) ||
        (broadcastStatus === BROADCAST_STATUS.ACCEPTED_INSIDE_PS && privateShowEnded) ||
        broadcastStatus === BROADCAST_STATUS.RECONNECTING ||
        broadcastStatus === BROADCAST_STATUS.INSIDE_PS ||
        broadcastStatus === BROADCAST_STATUS.DISCONNECTED ||
        isPrivateRoom ||
        guestPrivateRoom ||
        userKickedStatus ||
        isBanned);

    if (shouldExitFullscreen) {
      PlayerService.exitFullscreen();
    }

    if (userKickedStatus) {
      return <DesktopBroadcastKickedState />;
    }

    if (isBanned) {
      return <DesktopBroadcastBannedState />;
    }

    if (isPrivateRoom || guestPrivateRoom) {
      return (
        <DesktopBroadcastPrivateRoom
          roomName={roomName}
          setShowRegistrationModal={setShowRegistrationModal}
          user={user}
        />
      );
    }

    const isRealityShow = Boolean(realityShow?.mainProfile);
    const isMainEvent = Boolean(realityShow?.mainEvent);
    const isExternalProfile = Boolean(externalProfile?.isBroadcastingFromExternal);

    const hasEventAccess = isRealityShow && (isMainEvent || isExternalProfile);

    let streamStatus = broadcastStatus;
    if (hasEventAccess && streamStatus === BROADCAST_STATUS.INSIDE_PS) {
      streamStatus = BROADCAST_STATUS.PLAYING;
    }

    switch (streamStatus) {
      case BROADCAST_STATUS.PLAYING:
        if (newShowsState === NEW_SHOWS_STATE.PAUSED) {
          return <DesktopBroadcastPaused />;
        }

        return <DesktopStreaming embedProfileV2={embedProfileV2} history={history} user={user} />;
      case BROADCAST_STATUS.RECONNECTING:
        return <DesktopBroadcastReconnect />;
      case BROADCAST_STATUS.INSIDE_PS:
        if (newShowsState === NEW_SHOWS_STATE.PAUSED) {
          return <DesktopBroadcastPaused />;
        }
        if (spyShowEnded) {
          return (
            <MobilePrivateShowEnded
              embedProfileV2={embedProfileV2}
              isDesktop={true}
              isSpyingShow={true}
              showBuyTokensModal={showBuyTokensModal}
              user={user}
            />
          );
        }

        return (
          <DesktopBroadcastEnterSpy
            accessLevel={user.accessLevel}
            handlePrivateShowAction={this.handlePrivateShowAction}
            isSfw={isSfw}
            showBuyTokensModal={showBuyTokensModal}
          />
        );
      case BROADCAST_STATUS.INSIDE_GS:
        if (newShowsState === NEW_SHOWS_STATE.PAUSED_GS) {
          return <GroupShowDisconnectedState isDesktop={true} roomName={roomName} />;
        }
        if (newShowsState === NEW_SHOWS_STATE.PAUSED) {
          return <DesktopBroadcastPaused />;
        }
        if (userHoldGroupShowTicket) {
          return (
            newShowsDetails && (
              <GroupShowDesktop
                isUserInRoster={isUserInRoster(user.username) || isAdmin}
                roomDataReady={roomDataReady}
                roomName={roomName}
                user={user}
              />
            )
          );
        }

        return (
          newShowsDetails && (
            <GroupShowWithoutTicket
              isDesktop={true}
              roomName={roomName}
              showBuyTokensModal={showBuyTokensModal}
              user={user}
              walletDetails={walletDetails}
            />
          )
        );

      case BROADCAST_STATUS.DISCONNECTED:
        if (newShowsState === NEW_SHOWS_STATE.PAUSED) {
          return <DesktopBroadcastPaused />;
        }
        if (publicShowEnded) {
          return (
            <MobilePrivateShowEnded
              embedProfileV2={embedProfileV2}
              isDesktop={true}
              isPublicShow={true}
              isSpyingShow={true}
              showBuyTokensModal={showBuyTokensModal}
              user={user}
            />
          );
        }

        return <DesktopBroadcastDisconnected embedProfileV2={embedProfileV2} user={user} />;
      case BROADCAST_STATUS.ACCEPTED_INSIDE_PS:
        if (!privateShowReady && !SessionStorageService.get('privateShowTransitionDone')) {
          return <MobileShowTransition isDesktop={true} user={user} />;
        }
        if (privateShowEnded) {
          return (
            <MobilePrivateShowEnded
              embedProfileV2={embedProfileV2}
              isDesktop={true}
              showBuyTokensModal={showBuyTokensModal}
              user={user}
            />
          );
        }

        return <DesktopStreaming embedProfileV2={embedProfileV2} user={user} />;
      case BROADCAST_STATUS.SPYING:
        if (spyShowEnded) {
          return (
            <MobilePrivateShowEnded
              embedProfileV2={embedProfileV2}
              isDesktop={true}
              isSpyingShow={true}
              showBuyTokensModal={showBuyTokensModal}
              user={user}
            />
          );
        }

        return <DesktopStreaming embedProfileV2={embedProfileV2} user={user} />;
      case BROADCAST_STATUS.UNKNOWN:
        if (newShowsState === NEW_SHOWS_STATE.PAUSED) {
          return <DesktopBroadcastPaused />;
        }

        return <DesktopStreaming embedProfileV2={embedProfileV2} history={history} user={user} />;
      default:
        if (newShowsState === NEW_SHOWS_STATE.PAUSED) {
          return <DesktopBroadcastPaused />;
        }

        return <DesktopStreaming embedProfileV2={embedProfileV2} history={history} user={user} />;
    }
  };

  handlePrivateChat = (tabValue) => {
    const { togglePrivateMessages, setProfileChatTabValue } = ChatStore;
    togglePrivateMessages(true);
    setProfileChatTabValue(tabValue);
  };

  handleUserList = (value) => {
    const { setProfileChatTabValue } = ChatStore;
    const { user, setShowRegistrationModal } = this.props;
    const isGuestBilling = user.accessLevel === ACCESS_LEVEL_NUM.GUEST_BILLING;
    if (!user.username) {
      setShowRegistrationModal(true, RegistrationModalCaller.DESKTOP_BROADCAST_USER_LIST);
    } else if (isGuestBilling) {
      ModalService.showModal(ModalService.MODAL_KEYS.GUEST_BILLING_MODAL, {
        close: ModalService.hideModal,
        show: true,
      });
    } else {
      setProfileChatTabValue(value);
    }
  };

  handleGameTab = (value) => {
    const { setProfileChatTabValue } = ChatStore;
    const {
      user,
      paymentActions: { showBuyTokensModal },
    } = this.props;
    if (!user.username) {
      showBuyTokensModal(true);
    } else {
      setProfileChatTabValue(value);
    }
  };

  get animationClosedCookieName() {
    const { user: { username } } = UserStore;
    const { onCamAnimation } = ThemeService.theme;
    if (!onCamAnimation?.cookieNamePrefix) {
      return undefined;
    }

    return `${onCamAnimation.cookieNamePrefix}_animation_cookie-${username || 'guest'}`;
  }

  handleOnCamAnimation = () => {
    const { onCamAnimation } = ThemeService.theme;
    if (onCamAnimation) {
      const hasBeenAlreadyClosed = CookieStorageService.get(this.animationClosedCookieName);

      if (!hasBeenAlreadyClosed) {
        this.onCamAnimationTimer = setTimeout(() => {
          this.setState({ showOnCamAnimation: true });
        }, onCamAnimation.delay || DEFAULT_ON_CAM_ANIMATION_DELAY);
      }
    }
  };

  handleAdChange = ({ method }) => {
    if (method === 'ads::start') {
      if (this.onCamAnimationTimer) {
        clearTimeout(this.onCamAnimationTimer);
      }
    } else if (method === 'ads::onContentResumeRequested') {
      this.handleOnCamAnimation();
    }
  };

  closeOnCamAnimation = () => {
    const { user: { accessLevel } } = UserStore;
    const isGold = accessLevel >= ACCESS_LEVEL_NUM.GOLD;
    const cookieLifeTime = isGold ? ON_CAM_CLOSED_COOKIE_LIFETIME_GOLD_MEMBERS : ON_CAM_CLOSED_COOKIE_LIFETIME;
    const cookieExpires = new Date();
    cookieExpires.setTime(cookieExpires.getTime() + cookieLifeTime);

    CookieStorageService.set(
      this.animationClosedCookieName,
      true,
      {
        path: '/',
        expires: cookieExpires,
      }
    );
    this.setState({ showOnCamAnimation: false });
  };

  renderCam2Cam = () => {
    const { user: { username } } = this.props;
    const { isCam2CamPSRequest } = ProfileStore;
    const {
      isPrivateShowRequestActive,
      newShowsDetails,
      isCam2CamShow,
      isAnotherUserInC2C,
    } = FirebaseStore;
    const isInPrivateShow = ProfileStore.broadcastStatus === BROADCAST_STATUS.ACCEPTED_INSIDE_PS;
    let isCam2Cam = isInPrivateShow && newShowsDetails?.cam2cam && isCam2CamShow;
    let previewOnly = false;

    if (isPrivateShowRequestActive && !isInPrivateShow && isCam2CamPSRequest) {
      isCam2Cam = true;
      previewOnly = true;
    }

    if (!isCam2Cam || isAnotherUserInC2C(username)) {
      return null;
    }

    return <Cam2CamBroadcast previewOnly={previewOnly} />;
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      user,
      paymentActions: { showBuyTokensModal },
      match,
      walletDetails,
      setShowRegistrationModal,
      embedProfileV2,
    } = this.props;
    const {
      isPrivateRoom,
      authData,
      newShowsState,
      userHavePSTicket,
      serverOffset,
      newShowsDetails,
      userKickedStatus,
      isBanned,
      boostRemainingTime,
    } = FirebaseStore;
    const { buyGroupShowTicketResponse, remainingTimeLeftUntillGroupShow, userHaveTicket } = GroupShowStore;
    const { openedPeekWindows } = PeekStore;
    const { showOnCamAnimation } = this.state;
    const roomName = match.params.user.toLowerCase();
    const {
      broadcastStatus,
      externalProfile,
      inTheatreMode,
      isViewerBroadcast,
      isPlayerBroadcastMode,
      mainEventSecondaryStream,
      realityShow,
    } = ProfileStore;

    const hideChat = broadcastStatus === BROADCAST_STATUS.DISCONNECTED && newShowsState !== NEW_SHOWS_STATE.PAUSED;
    // TODO: this has to be removed once we fully transfer profiles to v2
    const guestPrivateRoom = authData.status === FIREBASE_AUTH_STATUS.privateRoom && !user.username;
    const videoAndChatClasses = classnames(styles.videoAndChatWrap, VIDEO_AND_CHAT_CLASS);
    const showPublicChatCF = UserStore.hasCF(allUserGroups.PROFILES_V2_SPECIAL_SHOW_PUBLIC_CHAT);

    let isChatLocked =
      (!userHavePSTicket(user.username) && newShowsState === NEW_SHOWS_STATE.INSIDE_PS && !showPublicChatCF) ||
      isPrivateRoom ||
      guestPrivateRoom ||
      ((newShowsState === NEW_SHOWS_STATE.INSIDE_GS ||
        newShowsState === NEW_SHOWS_STATE.BONUS_GS ||
        newShowsState === NEW_SHOWS_STATE.PAUSED_GS) &&
        !userHaveTicket(user.username) &&
        !showPublicChatCF);

    const isRealityShow = Boolean(realityShow?.mainProfile);
    const isMainEvent = Boolean(realityShow?.mainEvent);
    const isExternalProfile = Boolean(externalProfile?.isBroadcastingFromExternal);

    const hasEventAccess = isRealityShow && (isMainEvent || isExternalProfile);

    if (hasEventAccess) {
      isChatLocked = false;
    }

    const isShowEndedState =
      broadcastStatus === BROADCAST_STATUS.DISCONNECTED && newShowsState !== NEW_SHOWS_STATE.PAUSED;
    const isGroupShowBarVisible =
      !isShowEndedState &&
      (newShowsState === NEW_SHOWS_STATE.GS_SELLING_TICKETS ||
        newShowsState === NEW_SHOWS_STATE.GS_GOAL_REACHED ||
        ((newShowsState === NEW_SHOWS_STATE.INSIDE_GS || newShowsState === NEW_SHOWS_STATE.BONUS_GS) &&
          userHaveTicket(user.username))) &&
      !isBanned &&
      !userKickedStatus;
    const { hasAdminPrivileges } = UserStore;
    const chatWrapClasses = classnames({
      [styles.chatWrap]: true,
      [styles.chatWrapBroadcastMode]: isPlayerBroadcastMode,
      [styles.chatWrapExpanded]: BroadcasterStore.chatExpanded,
    });

    return (
      <div className={styles.profileVideoWrap} id="profileVideoWrap">
        {this.renderCam2Cam()}
        <div className={styles.videoSectionWrap}>
          <div className={videoAndChatClasses}>
            <div className={styles.videoContentWrap}>
              <div className={styles.streamWrapContainer}>
                <FeedsCarouselDesktopWrapper />
                <div className={styles.streamWrap} id="streamWrap">
                  {boostRemainingTime && <BoostAnimation isDesktop={true} />}
                  {showOnCamAnimation && (
                    <CampaignOnCamAnimation close={this.closeOnCamAnimation} showBuyTokensModal={showBuyTokensModal} />
                  )}
                  {this.handleRenderVideoState()}
                </div>
              </div>
              <div className={styles.videoInteractSectionWrapper} id="videoInteractSectionWrapper">
                {isGroupShowBarVisible && (
                  <DesktopGroupTicketBar
                    broadcasterName={roomName}
                    buyGroupShowTicket={buyGroupShowTicketResponse}
                    embedProfileV2={embedProfileV2}
                    goalReached={true}
                    newShowsDetails={newShowsDetails}
                    newShowsState={newShowsState}
                    remainingTimeLeftUntillGroupShow={remainingTimeLeftUntillGroupShow}
                    roomName={roomName}
                    serverOffset={serverOffset}
                    setShowRegistrationModal={setShowRegistrationModal}
                    showBuyTokensModal={showBuyTokensModal}
                    user={user}
                    walletDetails={walletDetails}
                  />
                )}
                {isViewerBroadcast && (
                  <div className={styles.tooltipContainer}>
                    <p className={styles.tooltipText}>User is broadcasting in viewer mode</p>
                    <Tooltip
                      // eslint-disable-next-line max-len
                      title="This stream is private. It won’t be listed on the Directory or show up on the user’s Profile page"
                    >
                      <Info color="inherit" />
                    </Tooltip>
                  </div>
                )}
                {!isShowEndedState && !isViewerBroadcast && (
                  <DesktopTipBar
                    embedProfileV2={embedProfileV2}
                    handlePrivateChat={this.handlePrivateChat}
                    handlePrivateShowAction={this.handlePrivateShowAction}
                    isChatLocked={isChatLocked}
                    isGroupShowBarVisible={isGroupShowBarVisible}
                    roomName={roomName}
                    setShowRegistrationModal={setShowRegistrationModal}
                    showBuyTokensModal={showBuyTokensModal}
                    user={user}
                  />
                )}
              </div>
            </div>
            {!hideChat && (
              <div className={chatWrapClasses} id="mainChatWrap">
                {(isChatLocked && !hasAdminPrivileges) || userKickedStatus || isBanned ? (
                  <DesktopBroadcastLockedChat />
                ) : (
                  <ChatTabs
                    {...this.props}
                    embedProfileV2={embedProfileV2}
                    handleGameTab={this.handleGameTab}
                    handlePrivateChat={this.handlePrivateChat}
                    handleUserList={this.handleUserList}
                  />
                )}
              </div>
            )}

            {inTheatreMode && (
              <NotificationRenderer />
            )}

            {inTheatreMode &&
              !embedProfileV2 &&
              openedPeekWindows.length > 0 &&
              openedPeekWindows.map((peek, index) => <PeekStream key={peek.performerName} index={index} info={peek} />)}

            {isMainEvent && mainEventSecondaryStream && (
              <PeekEventStream />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default DesktopBroadcast;
